import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
  ASSET_LIST, ASSET_DATA, ASSET_CREATE, ASSET_UPDATE, ASSET_DELETE,
  ASSET_BULK_ASSIGN,
  ASSET_NOTE_LIST, ASSET_NOTE_CREATE, ASSET_NOTE_UPDATE, ASSET_NOTE_DELETE,
  ASSET_ATTACHMENT_SEARCH, ASSET_ATTACHMENT_DELETE,
  ASSET_RECENT_ACTIVITY_LIST,
  ASSET_DIARY_SLOT_LIST,
} from "./actionType";
import {
  assetListSuccess, assetListFailure,
  assetDataSuccess, assetDataFailure,
  assetCreateSuccess, assetCreateFailure,
  assetUpdateSuccess, assetUpdateFailure,
  assetDeleteSuccess, assetDeleteFailure,
  assetBulkAssignSuccess, assetBulkAssignFailure,
  assetNoteListSuccess, assetNoteListFailure,
  assetNoteCreateSuccess, assetNoteCreateFailure,
  assetNoteUpdateSuccess, assetNoteUpdateFailure,
  assetNoteDeleteSuccess, assetNoteDeleteFailure,
  assetAttachmentSearchSuccess, assetAttachmentSearchFailure,
  assetAttachmentDeleteSuccess, assetAttachmentDeleteFailure,
  assetRecentActivityListSuccess, assetRecentActivityListFailure,
  assetDiarySlotListSuccess, assetDiarySlotListFailure,
} from "./action";
import {
  assetListApi, assetDataApi, assetCreateApi, assetUpdateApi, assetDeleteApi,
  assetBulkAssignApi,
  assetNoteListApi, assetNoteCreateApi, assetNoteUpdateApi, assetNoteDeleteApi,
  assetAttachmentSearchApi, assetAttachmentDeleteApi,
  assetRecentActivityListApi,
  assetDiarySlotListApi,
} from "../../helpers/fakebackend_helper";

function* handleList()            { try { yield put(assetListSuccess(yield call(assetListApi)));              } catch (e) { yield put(assetListFailure(e));   } }
function* handleData({ payload }) { try { yield put(assetDataSuccess(yield call(assetDataApi, payload)));     } catch (e) { yield put(assetDataFailure(e));   } }
function* handleCreate({ payload }){ try { yield put(assetCreateSuccess(yield call(assetCreateApi, payload)));} catch (e) { yield put(assetCreateFailure(e)); } }
function* handleUpdate({ payload }){ try { yield put(assetUpdateSuccess(yield call(assetUpdateApi, payload)));} catch (e) { yield put(assetUpdateFailure(e)); } }
function* handleDelete({ payload }){ try { yield put(assetDeleteSuccess(yield call(assetDeleteApi, payload)));} catch (e) { yield put(assetDeleteFailure(e)); } }

function* handleBulkAssign({ payload }) { try { yield put(assetBulkAssignSuccess(yield call(assetBulkAssignApi, payload))); } catch (e) { yield put(assetBulkAssignFailure(e)); } }

function* handleNoteList({ payload })   { try { yield put(assetNoteListSuccess(yield call(assetNoteListApi, payload)));     } catch (e) { yield put(assetNoteListFailure(e));   } }
function* handleNoteCreate({ payload }) { try { yield put(assetNoteCreateSuccess(yield call(assetNoteCreateApi, payload))); } catch (e) { yield put(assetNoteCreateFailure(e)); } }
function* handleNoteUpdate({ payload }) { try { yield put(assetNoteUpdateSuccess(yield call(assetNoteUpdateApi, payload))); } catch (e) { yield put(assetNoteUpdateFailure(e)); } }
function* handleNoteDelete({ payload }) { try { yield put(assetNoteDeleteSuccess(yield call(assetNoteDeleteApi, payload))); } catch (e) { yield put(assetNoteDeleteFailure(e)); } }

function* handleAttachmentSearch({ payload }) { try { yield put(assetAttachmentSearchSuccess(yield call(assetAttachmentSearchApi, payload))); } catch (e) { yield put(assetAttachmentSearchFailure(e)); } }
function* handleAttachmentDelete({ payload }) { try { yield put(assetAttachmentDeleteSuccess(yield call(assetAttachmentDeleteApi, payload))); } catch (e) { yield put(assetAttachmentDeleteFailure(e)); } }

function* handleRecentActivity({ payload }) { try { yield put(assetRecentActivityListSuccess(yield call(assetRecentActivityListApi, payload))); } catch (e) { yield put(assetRecentActivityListFailure(e)); } }

function* handleDiarySlotList({ payload }) { try { yield put(assetDiarySlotListSuccess(yield call(assetDiarySlotListApi, payload))); } catch (e) { yield put(assetDiarySlotListFailure(e)); } }

export default function* AssetSaga() {
  yield all([
    fork(function* () { yield takeEvery(ASSET_LIST,   handleList);   }),
    fork(function* () { yield takeEvery(ASSET_DATA,   handleData);   }),
    fork(function* () { yield takeEvery(ASSET_CREATE, handleCreate); }),
    fork(function* () { yield takeEvery(ASSET_UPDATE, handleUpdate); }),
    fork(function* () { yield takeEvery(ASSET_DELETE, handleDelete); }),
    fork(function* () { yield takeEvery(ASSET_BULK_ASSIGN, handleBulkAssign); }),
    fork(function* () { yield takeEvery(ASSET_NOTE_LIST,   handleNoteList);   }),
    fork(function* () { yield takeEvery(ASSET_NOTE_CREATE, handleNoteCreate); }),
    fork(function* () { yield takeEvery(ASSET_NOTE_UPDATE, handleNoteUpdate); }),
    fork(function* () { yield takeEvery(ASSET_NOTE_DELETE, handleNoteDelete); }),
    fork(function* () { yield takeEvery(ASSET_ATTACHMENT_SEARCH, handleAttachmentSearch); }),
    fork(function* () { yield takeEvery(ASSET_ATTACHMENT_DELETE, handleAttachmentDelete); }),
    fork(function* () { yield takeEvery(ASSET_RECENT_ACTIVITY_LIST, handleRecentActivity); }),
    fork(function* () { yield takeEvery(ASSET_DIARY_SLOT_LIST, handleDiarySlotList); }),
  ]);
}
